import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_event_management_audit_trail_RowClass } from '../../../dbschema';

export class EventManagementAuditTrailContainer extends BaseContainerModel {
  bl_cms_event_management_audit_trail: bl_cms_event_management_audit_trail_RowClass = new bl_cms_event_management_audit_trail_RowClass();
}
